var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"cursor-pointer speed-counter",class:{'speed-counter--dark-mode': _vm.darkMode},on:{"click":function($event){return _vm.changeSpeed(_vm.rate)}}},[_vm._v(_vm._s(_vm.toGermanString())+" x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }